import React from "react";
import { Link } from "react-router-dom";

/*eslint-disable */

interface OtherPageComponentProps {
  callToAction: any;
}
const OtherPageComponent: React.FC<OtherPageComponentProps> = ({
  callToAction,
}) => {
  return (
    <div className="other-page-home-component">
      <h2 className="title-other-page-home-component">Más oportunidades</h2>
      <div className="pages-other-page-home-component">
        {callToAction.map(
          (item: any, index: number) => (
            <div
              className="small-page-other-page-home-component"
              style={{ backgroundImage: `URL(https://manager.hyundaicolombia.co/${item.image.url})` }}
            >
              <div className="mascara-page-other-page-home-component">
                <h3 className="name-page-other-page-home-component">
                  {item.title}
                </h3>
                <h4 className="btn-page-other-page-home-component">
                  <Link to={item.url}>
                    Conocer
                  </Link>
                </h4>
              </div>
            </div>
          )
        )}
      </div>
    </div>
  );
};

export default OtherPageComponent;
